export const styles = () => ({
  input: {
    '& > input': {
      opacity: 0,
      width: 0,
      height: 0,
      position: 'absolute',
    },
    '& > label': {
      cursor: 'pointer',
      fontSize: 14,
      padding: '8px 16px',
      border: '1px solid rgba(22, 88, 243, 1)',
      borderRadius: 4,
      color: 'rgba(22, 88, 243, 1)',
      width: 'fit-content',
      fontWeight: 500,
      backgroundColor: '#ffffff',
      margin: '30px 0px 0px 0px',
      '& > span': {
        margin: '0px 6px 0px 0px',
      },
    },
  },
})
